import React, {FC} from 'react'

import paymentMethodsImage from './payment-methods.png'

type PaymentIcon = FC<{
  w?: number
  h?: number
  className?: string
}>

// Exsportia Pay Icon - White rounded rectangle with three diagonal bars
export const ExsportiaPayIcon: PaymentIcon = ({w = 40, h = 25, className}) => (
  <svg
    width={w}
    height={h}
    viewBox='0 0 40 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <rect
      x='2'
      y='0.5'
      width='36'
      height='24'
      rx='4'
      fill='white'
      stroke='#00103D'
      strokeOpacity='0.12'
    />
    <rect
      x='12.5'
      y='6.5'
      width='5'
      height='15'
      rx='2.5'
      transform='rotate(30 12.5 6.5)'
      fill='#F53769'
    />
    <rect
      x='21.3301'
      y='4.5'
      width='5'
      height='15'
      rx='2.5'
      transform='rotate(30 21.3301 4.5)'
      fill='#FFB700'
    />
    <rect
      x='30.1602'
      y='2.5'
      width='5'
      height='15'
      rx='2.5'
      transform='rotate(30 30.1602 2.5)'
      fill='#1DB265'
    />
  </svg>
)

// Visa Icon
export const VisaIcon: PaymentIcon = ({w = 40, h = 24, className}) => (
  <svg
    width={w}
    height={h}
    viewBox='0 0 1000 323.653'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M116.145 95.719H97.858L109.296 24.995H127.582L116.145 95.719Z'
      fill='#00579F'
    />
    <path
      d='M182.437 26.724C178.83 25.293 173.109 23.713 166.035 23.713C147.976 23.713 135.259 33.343 135.181 47.111C135.031 57.269 144.186 62.911 151.108 66.298C158.183 69.759 160.588 72.018 160.588 75.103C160.516 79.841 154.871 82.025 149.606 82.025C142.305 82.025 138.393 80.899 132.448 78.263L130.04 77.133L127.481 92.889C131.77 94.843 139.672 96.577 147.876 96.653C166.064 96.653 178.556 87.172 178.704 72.5C178.777 64.449 173.89 58.28 163.354 53.239C156.958 50.003 153.041 47.821 153.041 44.51C153.116 41.5 156.354 38.417 163.574 38.417C169.519 38.266 173.887 39.695 177.196 41.125L178.85 41.876L181.337 26.604L182.437 26.724Z'
      fill='#00579F'
    />
    <path
      d='M206.742 70.664C208.248 66.601 214.043 50.876 214.043 50.876C214.119 50.876 215.698 46.738 216.601 44.105L217.879 50.199C217.879 50.199 221.342 67.128 222.094 70.664C219.236 70.664 210.506 70.664 206.742 70.664ZM229.315 24.995H215.17C210.808 24.995 207.494 26.273 205.612 30.863L178.449 95.719H196.637C196.637 95.719 199.796 84.99 200.474 82.91C202.579 82.91 220.775 82.91 223.483 82.91C224.008 85.393 225.665 93.519 225.665 93.519H241.247L229.315 24.995Z'
      fill='#00579F'
    />
    <path
      d='M82.584 24.995L64.675 73.222L62.718 63.441C59.407 52.155 49.023 39.893 37.435 33.796L16.404 95.644H34.742L48.045 24.995H82.584Z'
      fill='#00579F'
    />
    <path
      d='M48.045 24.995L18.623 26.424L18.322 27.853C22.951 33.722 38.151 47.869 44.396 64.873L56.322 30.94C55.269 26.423 52.033 25.144 48.045 24.995Z'
      fill='#FAA61A'
    />
  </svg>
)

// Mastercard Icon
export const MastercardIcon: PaymentIcon = ({w = 40, h = 24, className}) => (
  <svg
    width={w}
    height={h}
    viewBox='0 0 999.2 776'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <rect
      x='364'
      y='66.1'
      width='270.4'
      height='485.8'
      fill='#FF5A00'
    />
    <path
      d='M382 309C382 210.3 428.3 121.9 499.6 66.1C447.2 24.9 381.1 0 309 0C138.2 0 0 138.2 0 309C0 479.8 138.2 618 309 618C381.1 618 447.2 593.1 499.6 551.9C428.3 496.1 382 407.7 382 309Z'
      fill='#EB001B'
    />
    <path
      d='M999.2 309C999.2 479.8 861 618 690.1 618C618 618 551.9 593.1 499.6 551.9C570.8 496.1 617.2 407.7 617.2 309C617.2 210.3 570.8 122.7 499.6 66.1C551.9 24.9 618 0 690.1 0C861 0 999.2 139.1 999.2 309Z'
      fill='#F79E1B'
    />
  </svg>
)

// Prompt Pay Icon - Simplified text representation
export const PromptPayIcon: PaymentIcon = ({w = 60, h = 24, className}) => (
  <svg
    width={w}
    height={h}
    viewBox='0 0 120 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    {/* Prompt text - blue with white outline effect */}
    <text
      x='5'
      y='22'
      fontSize='14'
      fontWeight='600'
      fill='#00579F'
      stroke='white'
      strokeWidth='0.8'
      fontFamily='Arial, sans-serif'
    >
      Prompt
    </text>
    {/* Pay text - solid blue */}
    <text
      x='60'
      y='22'
      fontSize='14'
      fontWeight='600'
      fill='#00579F'
      fontFamily='Arial, sans-serif'
    >
      Pay
    </text>
  </svg>
)

// Payment Methods Group Component - shows all payment methods together using PNG image
export const PaymentMethodsGroup: FC<{w?: number; h?: number; className?: string}> = ({w = 120, h = 24, className}) => (
  <img
    src={paymentMethodsImage}
    alt='Payment methods'
    style={{
      width: w,
      height: h,
      maxWidth: '100%',
      objectFit: 'contain',
    }}
    className={className}
  />
)

